import { motion } from 'motion/react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { WinnerTitle } from './WinnerTitle';
import { Message } from '../Message/Message';
import { Confetti } from '../Confetti/Confetti';

import styles from './MessagesList.module.css';

export const MessagesList = ({
  messages,
  authorFontSize,
  currentState,
  winId,
  speed,
  messagesRef,
}) => {
  const isWinner =
    currentState === 'S7' ||
    (currentState === 'S4' && messagesRef?.length === 1);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={styles['wrapper']}
    >
      {isWinner && (
        <WinnerTitle className={styles.winnerTitle} startDelay={1.5} />
      )}

      {currentState === 'S4' ? (
        messagesRef?.length === 1 ? (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
            style={{ marginTop: '20rem' }}
          >
            <Message
              message={messagesRef[0].message}
              currentState={currentState}
              winId={messagesRef[0].message?.id}
              authorFontSize={authorFontSize}
            />
          </motion.div>
        ) : null
      ) : (
        <div className={styles.messagesWrapper}>
          <TransitionGroup className={styles.messages}>
            {messages.length > 0 &&
              messages.map((item, i) => (
                <CSSTransition
                  key={item.UUID}
                  timeout={speed}
                  classNames="position"
                >
                  <Message
                    winId={winId}
                    key={item.id}
                    message={item.message}
                    titrTag={item.titrTag}
                    authorFontSize={authorFontSize}
                    currentState={currentState}
                  />
                </CSSTransition>
              ))}
          </TransitionGroup>
        </div>
      )}

      {isWinner && <Confetti />}
    </motion.div>
  );
};
